import React from 'react';
import { DataGrid, DataColumn, DateGridCell } from '../components';

class ReportAccessGrid extends React.Component {

    render () {
        return (
            <DataGrid {...this.props} className={['component-report-access-grid', this.props.className].join(' ')}>
                <DataColumn columnName="sampleNumber" displayName="Sample Number" />
                <DataColumn columnName="serialNumber" displayName="Serial #" />
                <DataColumn columnName="customerName" displayName="Customer" />
                <DataColumn columnName="displayName" displayName="User" />
                <DataColumn columnName="client" displayName="Client" />
                <DataColumn columnName="accessMethod" displayName="Access Method" />
                <DataColumn columnName="dateAccessed" displayName="Date Accessed" cellComponent={DateGridCell} />
            </DataGrid>
        )
    }
}

export default ReportAccessGrid;



// WEBPACK FOOTER //
// ./web-app/components/report-access-grid.jsx